<ng-container *ngIf="notificationState$ | async as state; else loader">
  <button
    (click)="onClick()"
    type="button"
    cdkOverlayOrigin
    aria-label="Wiadomości"
    class="clear-button icon-button"
    [class.active]="visible"
    [class.disabled]="appConfig.config.applicationReadOnlyMode"
    #trigger="cdkOverlayOrigin"
    matTooltip="Funkcjonalność jest aktualnie niedostępna"
    [matTooltipDisabled]="!appConfig.config.applicationReadOnlyMode">
    <app-icon [@shake]="animationState"
              style="transform-origin: top center;"
              name="notifications_active"
              [color]="appConfig.config.applicationReadOnlyMode ? '#575481' : visible ? '#575481' : '#575481'">
    </app-icon>
    <div *ngIf="state.unreadCount > 0 && !appConfig.config.applicationReadOnlyMode" class="badge"
         [ngStyle]="{'backgroundColor': newNotification ? '#C92121' : null }">
      {{ state.unreadCount }}
    </div>
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="visible"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'transparent'"
    [cdkConnectedOverlayFlexibleDimensions]="handsetService.isXs"
    (backdropClick)="visible = false">
    <div class="container" ngClass.xs="xs">
      <div class="header" [class.bold]="!handsetService.isXs" style="margin-bottom: 0;">
        <button mat-icon-button *ngIf="handsetService.isXs" class="back-btn" (click)="visible = false">
          <app-icon name="arrow_back" color="#575481"></app-icon>
        </button>
        <span class="title" ngClass.xs="xs">Powiadomienia</span>
      </div>
      <ng-container *ngIf="state?.notifications?.length > 0; then setAllToRead"></ng-container>
      <ng-template #setAllToRead>
        <ng-container *ngIf="state?.unreadCount > 0; else setAllToUnread">
          <app-new-loader-button
            type="flat"
            class="set-all-to-status-button"
            [appApiCallLoading]="setAllNotificationsToRead"
          >
            Oznacz wszystkie jako przeczytane
          </app-new-loader-button>
        </ng-container>
      </ng-template>
      <ng-template #setAllToUnread>
        <app-new-loader-button
          type="flat"
          class="set-all-to-status-button"
          [appApiCallLoading]="setAllNotificationsToUnread"
        >
          Oznacz wszystkie jako nieprzeczytane
        </app-new-loader-button>
      </ng-template>
      <div
        *ngIf="state.notifications?.length; else emptyState"
        class="content" ngClass.xs="xs" infinite-scroll
        [scrollWindow]="false"
        (scrolled)="onScrollDown()">
        <ng-container *ngFor="let notification of state.notifications">
          <app-notifications-container-row
            [notification]="notification"
            (handleClose)="visible = false"
          ></app-notifications-container-row>
        </ng-container>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loader>
  <mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
<ng-template #emptyState>
  <app-notifications-container-empty-state
    class="empty-state"
    (handleClose)="visible = false">
  </app-notifications-container-empty-state>
</ng-template>
